import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Ipremiumtranscations } from 'src/app/sidenav/helper';
import { HomeService } from 'src/app/services/homeservice';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DynamicTabsService } from 'src/app/dynamic-tabs.service';
import { MatSort } from '@angular/material/sort';
@Component({
  selector: 'app-premiumtransactions',
  templateUrl: './premiumtransactions.component.html',
  styleUrls: ['./premiumtransactions.component.css']
})
export class PremiumtransactionsComponent {
  headerTitle: string | undefined;
  @Input() IsHomeClicked: boolean = false;
  @Input() id: number = 0;
  @Input() label: string = '';
  @Input() type: string = '';
  premiumtrans!: Ipremiumtranscations[];
  searchTerm: string = '';
  filteredData: Ipremiumtranscations[] = [];
  originalData!: Ipremiumtranscations[];
  sortingColumn: string = '';
  sortOrder: 'asc' | 'desc' = 'asc';
  isSearching: boolean = false;
  currentPage: number = 1;
  dataSource!: MatTableDataSource<Ipremiumtranscations>;
  totalItems: number = 0;
  currentPageIndex: number = 0;
  pageSize: number = 45;
  pageSizeOptions: number[] = [45, 90, 135,225,];
  isHidePageSize: boolean = true;
  showFirstLastButtons = true;
  isLoading: boolean=false;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort,{static:true})sort!:MatSort;
  columnsToDisplay: string[] = [
    'masterPolicyNumber',
    'memberPolicyNumber',
    'transactionDate',
    'transactionType',
    'insuredValueChange',
    'premiumChange',
    'empty'

  ]
  constructor(private service: HomeService, public dynamicTabsService: DynamicTabsService) {
    this.dataSource = new MatTableDataSource<Ipremiumtranscations>([]);
  }
  ngOnInit(): void {

    this.getPremiumTransactions();
    this.dynamicTabsService.refreshObv.subscribe(value => {
      if (value && this.dynamicTabsService.selectedTab == 'Premium Transactions')
        this.refresh();
    })

    this.loadTableData();
  }

  ngAfterViewInit()
  {
    this.paginator.pageSize=45;
    this.checkRowsPerPage();
  }
  //event listener for searching
  @HostListener('document:keyup.enter',['$event'])
  handleEnterKey(event:KeyboardEvent)
  {
    if(event.key==='Enter')
    {
      this.search();
    }
  }
  //checking number of rows per page
  checkRowsPerPage() {
    if (this.paginator) {
      const rowsPerPage = this.paginator.pageSize;
      // console.log(`Number of rows per page:${rowsPerPage}`);
    }
  }

  loadTableData()
  {
    this.isLoading=true;
   this.getPremiumTransactions();
  }
  refresh() {
    if(this.dynamicTabsService.selectedTabData.id==-9){
    this.isLoading=true;
    this.getPremiumTransactions();
    this.clearSearch();
    // console.log("Premium transactions refreshed");
  }
  }


  onPageChange(event: any): void {
    this.currentPageIndex = event.pageIndex;
    this.pageSize = 45;
    this.applyPagination();
  }

  getPremiumTransactions() {
    this.service.GetPremiumTransactions().subscribe((res: any[]) => {
      this.premiumtrans = res;
      this.filteredData = this.premiumtrans;
      this.totalItems = this.filteredData.length;
      this.applyPagination();
      this.isLoading = false;
      res.sort((a,b)=>
      {
        const dateA = parseFloat(a.transactionDate);
        const dateB = parseFloat(b.transactionDate);
      // console.log("StartedDate sorted ascending while loading PremiumTransactions apps");
      return (dateA)-(dateB);
   
      });
      this.dataSource.data=this.premiumtrans.slice(0,45);
      this.dataSource.sort=this.sort;
    })
  }
  @Output() openDetailTab = new EventEmitter();
  openPolicy(transaction: any) {
    this.openDetailTab.emit({ id: transaction.masterPolicyId, label: transaction.masterPolicyNumber + '-policy', type: 'policy' });
    // console.log(transaction.id);
  }
  pageChanged(page: number): void {
    this.currentPage = page;
  }
  filterData(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.filteredData = this.dataSource.data.slice(startIndex, endIndex);
  }
  applyPagination(): void {
    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.dataSource.data = this.filteredData.slice(startIndex, endIndex);

  }
  applyFilter(): void {
    this.pageSize=45;
    this.currentPageIndex = 0;
    const searchValue = this.searchTerm.trim().toLowerCase();
    this.filteredData = this.premiumtrans.filter((item) => {
      const searchFields = [item.masterPolicyNumber, item.memberPolicyNumber, item.transactionDate, item.transactionType, item.insuredValueChange, item.premiumChange];
      return searchFields.some((field) => String(field).toLowerCase().includes(searchValue));
    });
    this.totalItems = this.filteredData.length;
    this.isSearching = searchValue != '';
    this.applyPagination();
  }
  search(): void {
    this.applyFilter();
  }
  clearSearch(): void {
    this.pageSize=45;
    this.currentPageIndex=0;
    this.searchTerm = '';
    this.isSearching = false;
    this.filteredData = this.premiumtrans;
    this.totalItems = this.premiumtrans.length;
    this.applyPagination();
  }

  sortData(column: keyof Ipremiumtranscations) {
    if (this.sortingColumn == column) {

      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    }
    else {
      this.sortingColumn = column;
      this.sortOrder = 'asc';
    }
    this.premiumtrans.sort((a, b) => {
        const valueA =( a[column] || '').toString();
        const valueB = (b[column] || '').toString();
  //compare mixed-case values
        if (valueA.toLowerCase() < valueB.toLowerCase()) {
          return this.sortOrder === 'asc' ? -1 : 1;
        }
  
        else if (valueA.toLowerCase() > valueB.toLowerCase()) {
          return this.sortOrder === 'asc' ? 1 : -1;
        }
  
       //Handle empty values
       if(valueA === '' && valueB ===''){
        return 0;
       }else if(valueA === ''){
        return -1;
       }else if(valueB === ''){
        return 1;
       }
       return 0;
  
      });
    this.applyPagination();
  }
}


